<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" sm="6" md="8">
          <v-text-field v-model="editedField.data.title" label="Title"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="8">
          <v-select
            :items="typesTitles"
            label="Value type"
            v-model="editedField.data.type"
          ></v-select>
        </v-col>
      </v-row>

      <v-row v-if="editedField.data.type == FIELD_TYPES.TEXT">
        <v-radio-group v-model="editedField.data.attrs.textType" mandatory="true">
          <v-radio
            v-for="textType in textTypes"
            :key="textType"
            :label="textType"
            :value="textType"
            :checked="editedField.data.attrs.textType == textType"
          ></v-radio>
        </v-radio-group>
      </v-row>

      <v-row v-if="editedField.data.type == FIELD_TYPES.NUMBER">
        <v-col cols="12" sm="6" md="4">
          <v-checkbox
            v-model="editedField.data.attrs.hasMin"
            color="primary"
            label="Has min value"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6" md="4" v-if="editedField.data.attrs.hasMin">
          <v-text-field
            v-model="editedField.data.attrs.min"
            label="Min value"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="editedField.data.type == FIELD_TYPES.NUMBER">
        <v-col cols="12" sm="6" md="4">
          <v-checkbox
            v-model="editedField.data.attrs.hasMax"
            color="primary"
            label="Has max value"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6" md="4" v-if="editedField.data.attrs.hasMax">
          <v-text-field
            v-model="editedField.data.attrs.max"
            label="Max value"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row v-if="editedField.data.type == FIELD_TYPES.SELECT_OPTIONS">
        <v-data-table
          :headers="optHeaders"
          :items="this.editedField.data.attrs.options"
          class="elevation-1"
        >
          <template v-slot:item.imgId="{ item }">
            <img
              v-if="item.imgId"
              :src="getImgFromBuffer(images[item.imgId])"
              style="max-width: 50px; max-height: 50px"
            />
          </template>

          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>Options</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>

              <div class="flex-grow-1"></div>

              <v-dialog v-model="dialogOpt" max-width="800px">
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark class="mb-2" v-on="on">New Option</v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ optFormTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col>
                          <v-text-field v-model="editedOpt.text" label="Title"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-checkbox
                            v-model="editedOpt.hasPrice"
                            @change="editedOpt.price = !editedOpt.hasPrice ? undefined : 0"
                            label="Has price"
                          ></v-checkbox>
                        </v-col>
                        <v-col v-if="editedOpt.hasPrice">
                          <v-text-field
                            v-model="editedOpt.price"
                            label="Value (price)"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-file-input
                            ref="fileInp"
                            accept="image/png, image/jpeg, image/bmp"
                            placeholder="Pick an product picture"
                            prepend-icon="camera_alt"
                            label="Product image"
                            :loading="loadingImage"
                            @change="fileInpChange"
                          ></v-file-input>
                        </v-col>
                        <v-col>
                          <v-badge color="red" v-if="editedOpt.imgId">
                            <template v-slot:badge>
                              <v-icon title="Remove image" @click="clearImage(editedOpt)"
                                >clear</v-icon
                              >
                            </template>
                            <v-img
                              v-if="editedOpt.imgId && !isImageNew"
                              :src="getImgFromBuffer(images[editedOpt.imgId])"
                              max-width="128"
                              max-height="128"
                            ></v-img>
                            <div v-if="isImageNew">
                              <v-badge overlap bottom color="purple" v-if="editedOpt.imgId">
                                <template v-slot:badge>
                                  <v-icon
                                    title="Rotate image"
                                    @click="rotateImageRight90(editedOpt)"
                                    >redo</v-icon
                                  >
                                </template>

                                <div>
                                  <v-badge
                                    overlap
                                    bottom
                                    left
                                    color="purple"
                                    v-if="editedOpt.imgId"
                                  >
                                    <template v-slot:badge>
                                      <v-icon
                                        title="Rotate image"
                                        @click="rotateImageLeft90(editedOpt)"
                                        >undo</v-icon
                                      >
                                    </template>

                                    <v-img
                                      v-if="editedOpt.imgId"
                                      :src="getImgFromBuffer(images[editedOpt.imgId])"
                                      max-width="128"
                                      max-height="128"
                                    ></v-img>
                                  </v-badge>
                                </div>
                              </v-badge>
                            </div>
                          </v-badge>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-textarea
                          v-model.trim="editedOpt.description"
                          :rows="5"
                          outline
                          placeholder="Type description for option"
                          rounded
                          :maxlength="100"
                          :counter="100"
                          clearable
                          solo
                        >
                        </v-textarea>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="blue darken-1" text @click="closeOptForm">Cancel</v-btn>
                    <v-btn :disabled="loadingImage" color="blue darken-1" text @click="addNewOpt"
                      >Save</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:item.action="{ item }">
            <v-icon small class="mr-2" @click="editOpt(item)">edit</v-icon>
            <v-icon small @click="deleteOpt(item)">delete</v-icon>
          </template>
        </v-data-table>
      </v-row>
      <v-row v-if="editedField.data.type == FIELD_TYPES.SELECT_OPTIONS">
        <v-card-text>
          <v-slider
            label="Using images mode: "
            v-model="editedField.data.imageMode"
            :tick-labels="getImageModesList()"
            :max="getImageModesList().length - 1"
            step="1"
            ticks="always"
            :tick-size="getImageModesList().length"
          ></v-slider>
        </v-card-text>
      </v-row>

      <v-row>
        <v-switch v-model="editedField.data.multiple" label="Multiple choises"></v-switch>
      </v-row>
      <v-row>
        <v-switch v-model="editedField.data.countable" label="Countable"></v-switch>
      </v-row>
      <v-row>
        <v-switch
          v-model="editedField.data.required"
          label="Required (without No option)"
        ></v-switch>
      </v-row>
      <v-row>
        <v-switch v-model="editedField.data.active" label="Active"></v-switch>
      </v-row>
      <v-row>
        <v-switch v-model="editedField.data.hasDependencies" label="Dependencies"></v-switch>
      </v-row>
      <v-row v-if="editedField.data.hasDependencies">
        <v-card class="mx-auto" tile>
          <v-list>
            <v-subheader>Dependencies list</v-subheader>
            <v-list-item-group color="primary">
              <v-list-item v-for="(radioField, i) in selectionListOfRadioFields" :key="i">
                <v-list-item-content>
                  <!-- <v-list-item-title
                    v-text="item.data.title"
                  ></v-list-item-title> -->
                  <v-select
                    v-model="editedField.data.dependencies[radioField.id]"
                    :items="radioField.items"
                    filled
                    chips
                    :label="radioField.title"
                    multiple
                  ></v-select>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import FIELD_TYPES from '@/constants/fieldTypes'
import TEXT_TYPES from '@/constants/textTypes'
import IMAGES_MODES from '@/constants/imageModes'

import { mapActions, mapGetters, mapMutations } from 'vuex'
import uniqid from 'uniqid'
import IMAGE_MODES from '@/constants/imageModes'
// import { threadId } from "worker_threads";

export default {
  name: 'Field',
  data: () => ({
    selectionListOfRadioFields: [],
    editedField: null,
    FIELD_TYPES,
    TEXT_TYPES,
    typesTitles: Object.keys(FIELD_TYPES).map(key => FIELD_TYPES[key]),
    textTypes: Object.keys(TEXT_TYPES).map(key => TEXT_TYPES[key]),
    dialogOpt: false,
    optHeaders: [
      {
        text: 'Title',
        value: 'text'
      },
      {
        text: 'Price',
        value: 'price'
      },
      {
        text: 'Img',
        value: 'imgId',
        sortable: false
      },
      {
        text: 'Actions',
        value: 'action',
        sortable: false
      }
    ],
    editedOpt: {
      text: '',
      hasPrice: true
    },
    defaultOpt: {
      text: '',
      hasPrice: true
    },

    loadingImage: false,
    isImageNew: true
  }),
  computed: {
    optFormTitle() {
      return this.editedOptIndex === -1 ? 'New Option' : 'Edit Option'
    },
    images() {
      return this.allImages()
    },
    fields() {
      return this.allFields()
    }
  },
  watch: {
    fields() {},
    dialog(val) {
      val || this.close()
    }
  },
  props: {
    field: {
      type: Object,
      default: null
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.editedField = this.field
    if (this.editedField.data.imageMode) {
      this.editedField.data.imageMode = Object.keys(IMAGE_MODES)
        .map(key => IMAGE_MODES[key])
        .findIndex(val => val == this.editedField.data.imageMode)
    }

    if (this.field.data.type == FIELD_TYPES.SELECT_OPTIONS) this.loadThumbnails(this.field)
    this.selectionListOfRadioFields = this.getSelectionListOfRadioFields()
  },

  methods: {
    ...mapActions('fields', ['setEditedField', 'setError']),
    ...mapActions('images', ['loadThumbnails']),
    ...mapGetters('images', ['allImages']),
    ...mapMutations('images', ['addImage', 'deleteImage', 'updateImage']),
    ...mapGetters('fields', ['allFields']),
    getSelectionObjectItemFromField(field) {
      const selectionObjItem = {
        id: field._id,
        title: field.data.title,
        items: field.data.attrs.options.map(opt => ({
          text: opt.text,
          value: opt.id
        })),
        values: []
      }
      if (
        this.editedField &&
        this.editedField.data.hasDependencies &&
        this.editedField.data.dependencies &&
        this.editedField.data.dependencies[field._id]
      ) {
        this.editedField.data.dependencies[field._id].forEach(optKey => {
          if (selectionObjItem.items.some(item => item.value == optKey))
            selectionObjItem.values.push(optKey)
        })
      }

      if (!this.editedField.data.dependencies) this.editedField.data.dependencies = {}
      this.editedField.data.dependencies[field._id] = selectionObjItem.values
      return selectionObjItem
    },
    getSelectionListOfRadioFields() {
      const selectionObjList = this.fields
        .filter(
          field =>
            (!this.editedField || (this.editedField && this.editedField._id != field._id)) &&
            field.data.type == FIELD_TYPES.SELECT_OPTIONS &&
            !field.data.multiple
        )
        .map(field => this.getSelectionObjectItemFromField(field))
      return selectionObjList
    },
    getImageModesList() {
      return Object.keys(IMAGES_MODES).map(key => IMAGES_MODES[key])
    },

    getImgFromBuffer(buffer) {
      try {
        return 'data:image/jpg;base64, ' + buffer.toString('base64')
      } catch {
        return 'no_image.jpg'
      }
    },

    clearImage(editedOpt) {
      this.deleteImage(editedOpt.imgId)
      this.fileInpChange(null)
      this.$refs.fileInp.internalValue = []
      this.loadingImage = false
    },

    rotateImageDegree(editedOpt, degree) {
      this.loadingImage = true
      const self = this
      Jimp.read(Buffer.from(this.images[editedOpt.imgId]))
        .then(image => {
          image.rotate(degree, false).getBuffer(Jimp.AUTO, (err, buffer) => {
            self.loadingImage = false
            if (err) {
              self.setError(err)
              return
            }
            self.updateImage({ _id: editedOpt.imgId, data: buffer })
            self.editedOpt = {
              ...self.editedOpt
            }
          })
        })
        .catch(err => {
          self.setError(err)
          self.loadingImage = false
        })
    },

    rotateImageLeft90(editedOpt) {
      this.rotateImageDegree(editedOpt, 90)
    },

    rotateImageRight90(editedOpt) {
      this.rotateImageDegree(editedOpt, -90)
    },

    fileInpChange(file) {
      if (!file) {
        this.editedOpt = {
          ...this.editedOpt,
          imgId: null
        }
        return
      }
      const self = this
      this.loadingImage = true
      var reader = new FileReader()
      reader.onload = function(event) {
        const imgId = uniqid()

        Jimp.read(event.target.result)
          .then(image => {
            image.scaleToFit(500, 500, Jimp.AUTO).getBuffer(Jimp.AUTO, (err, buffer) => {
              self.isImageNew = true
              self.loadingImage = false
              if (err) {
                self.setError(err)
                return
              }
              self.addImage({ _id: imgId, data: buffer })
              self.editedOpt = {
                ...self.editedOpt,
                imgId
              }
            })
          })
          .catch(err => {
            self.setError(err)
            self.loadingImage = false
          })
      }

      reader.onerror = function(event) {
        self.setError(event.target.error)
      }
      reader.readAsDataURL(file)
    },

    editOpt(item) {
      this.isImageNew = false
      this.editedOptIndex = this.editedField.data.attrs.options.indexOf(item)
      this.editedOpt = Object.assign({}, item)
      this.dialogOpt = true
      this.$refs.fileInp.internalValue = []
      this.loadingImage = false
    },

    deleteOpt(item) {
      const index = this.editedField.data.attrs.options.indexOf(item)
      if (confirm('Are you sure you want to delete this option?')) {
        delete this.editedField.data.attrs.options.splice(index, 1)
        this.editedField = {
          ...this.editedField
        }
      }
    },

    closeOptForm() {
      this.dialogOpt = false
      setTimeout(() => {
        this.editedOpt = Object.assign({}, this.defaultOpt)
        this.editedOptIndex = -1
        this.$refs.fileInp.internalValue = []
        this.loadingImage = false
      }, 300)
    },

    addNewOpt() {
      this.isImageNew = true
      if (this.editedOptIndex > -1) {
        Object.assign(this.editedField.data.attrs.options[this.editedOptIndex], this.editedOpt)
      } else {
        this.editedOpt.id = uniqid()
        this.editedField.data.attrs.options.push(Object.assign({}, this.editedOpt))
      }
      this.editedField = { ...this.editedField }
      this.closeOptForm()
    }
  }
}
</script>
<style lang="scss" scoped>
v-badge v-icon {
  cursor: pointer;
}
</style>
